import { gql } from '@apollo/client';

export default gql`
  query GetSystemProvider($id: Int!) {
    getSystemProvider(id: $id) {
      id
      name
      recipient_email
      is_active
      created_by
      letter_template_id
      letter_template_name
      createdAt
      updatedAt
    }
  }
`;
